import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss']
})
export class MasterPageComponent implements OnInit {

  @ViewChild('successModal')
  successModal: any;
  LoaderComponent: any = '';
  educationMasterForm: FormGroup;
  professionMasterForm:FormGroup;
  universityMasterForm:FormGroup;
  cityMasterForm:FormGroup;
  casteMasterForm:FormGroup;
  listOfEduCategory: any[] = [];
  listOfStates: any[] = [];
  listOfEduGroup: any[] = [];
  listOfEduSpecialization: any[] = [];
  listOfProfCategory: any[] = [];
  listOfProfGroup: any[] = [];
  listOfProfSpecialization: any[] = [];
  listOfUniversities: any[] = [];
  listOfCountries: any[] = [];
  listOfCastes: any[] = [];
  listOfSubCastes: any[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchableEduCategoryList: any[] = [];  
  searchableEduGroupList: any[] = [];  
  searchableEduSpecializationList: any[] = [];
  searchableProfCategoryList: any[] = [];  
  searchableProfGroupList: any[] = [];  
  searchableProfSpecializationList: any[] = [];  
  searchableUniversityList: any[] = [];  
  searchableCityList: any[] = [];
  searchableCasteList: any[] = [];
  
  searchableSubCasteList: any[] = [];
  CompleteCasteList: any[] = [];
  searchableCountryList: any[] = [];
  selectable = true;
  removable = true;
  addEduCategory:boolean=false;  
  addCountry:boolean = false;
  addCaste:boolean = false;
  addSubCaste:boolean = false;
  addEduGroup:boolean=false;
  addEduSpecialization:boolean=false;
  addProfCategory:boolean=false;  
  addProfGroup:boolean=false;
  addProfSpecialization:boolean=false;
  universityToMD:boolean=false;
  responseMessage:any;
  searchableStateList: any;
  addState: boolean = false;
  searchableDistrictList: any;
  listOfDistricts: any[] = [];
  listOfCities: any[] = [];
  addDistrict: boolean=false;
  addCity: boolean=false;
  selectedCountry: any;

  constructor(public service: WebRequestService) { }

   ngOnInit(){
    this.educationMasterForm = new FormGroup({
      highestEducation: new FormControl(''),
      educationGroup: new FormControl(''),
      specialization: new FormControl(''),
    })
    this.professionMasterForm = new FormGroup({
      highestprofession: new FormControl(''),
      professionGroup: new FormControl(''),
      profSpecialization: new FormControl(''),
    })
    this.universityMasterForm = new FormGroup({
      university: new FormControl(''),
    })
    this.cityMasterForm = new FormGroup({
      country: new FormControl(''),
      state: new FormControl(''),
      district : new FormControl(''),
      city: new FormControl(''),
    })
    
    this.casteMasterForm = new FormGroup({
      caste: new FormControl(''),
       subcaste: new FormControl('')

    })
    this.educationMasterForm.get('highestEducation').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredEduCategory(val,'HighestEducation');
      }
    })
    this.educationMasterForm.get('educationGroup').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredEduGroup(val,'EducationDegree');
      }
    })
    this.educationMasterForm.get('specialization').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredEduSpecialization(val,'Specialization',this.educationMasterForm.value.educationGroup.id);
      }
    })
    this.professionMasterForm.get('highestprofession').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredProfCategory(val,'YouWorkWith');
      }
    })
    this.professionMasterForm.get('professionGroup').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredProfGroup(val,'ProfessionalGroup');
      }
    })
    this.professionMasterForm.get('profSpecialization').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredProfSpecialization(val,'ProfessionAs',this.professionMasterForm.value.professionGroup.id);
      }
    })
    this.universityMasterForm.get('university').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredUniversity(val,'University');
      }
    })
    this.cityMasterForm.get('country').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredCountry(val,'Country');
      }
    })
    this.cityMasterForm.get('state').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredState(val,'StateBasedOnId', this.cityMasterForm.value.country.id);
      }
    })
    this.cityMasterForm.get('district').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredDistrict(val,'DistrictBasedOnId', this.cityMasterForm.value.state.id);
      }
    })
    this.cityMasterForm.get('city').valueChanges.subscribe(val => {
      if (val != null) {
        this.filteredCity(val,'CityBasedOnId', this.cityMasterForm.value.state.id);
      }
    })
  //  await this.casteMasterForm.get('caste').valueChanges.subscribe(val => {
  //     if (val != null) {
  //       this.filteredCaste(val,'Caste');
  //     }
  //   })
  }
  addToMasterData(mastername,makeInactiveType){
    switch (mastername) {
      case 'HighestEducation' :
        this.addMasterData(this.educationMasterForm.value, false)
        return
      case 'educationGroup' :
        this.addMasterData(this.educationMasterForm.value, false)
        return
      case 'specialization' :
        this.addMasterData(this.educationMasterForm.value, false)
        return
      case 'highestprofession' :
        this.addMasterDataProfession(this.professionMasterForm.value, false)
        return
      case 'professionGroup' :
        this.addMasterDataProfession(this.professionMasterForm.value, false)
        return
      case 'profSpecialization' :
        this.addMasterDataProfession(this.professionMasterForm.value, false)
        return
      case 'university' :
        this.addMasterDataUniversity(this.universityMasterForm.value, false)
        return
      case 'inactive' :
        makeInactiveType === 2 ? this.addMasterDataProfession(this.professionMasterForm.value, true) : this.addMasterData(this.educationMasterForm.value, true);
        return        
      case 'Country' : 
        this.addMasterDataCity(this.cityMasterForm.value, false)
        return
      case 'StateBasedOnId' : 
        this.addMasterDataCity(this.cityMasterForm.value, false)
        return
      case 'DistrictBasedOnId' : 
        this.addMasterDataCity(this.cityMasterForm.value, false)
        return
      case 'CityBasedOnId' : 
        this.addMasterDataCity(this.cityMasterForm.value, false)
      case 'caste' : 
        this.addMasterDataCaste(this.casteMasterForm.value, false)
      case 'GroupCaste' : 
        this.addMasterDataSubCaste(this.casteMasterForm.value, false)
        return
    }
  }

  addMasterData(data, makeInactive){
    let masterData = {
      categoryID :  typeof(data.highestEducation) == 'object' ? data.highestEducation.id : null,
      categoryName : typeof(data.highestEducation) == 'object' ? data.highestEducation.value : data.highestEducation,
      masterType : 1,
      groupID : typeof(data.educationGroup) == 'object' ? data.educationGroup.id : null,
      groupName : typeof(data.educationGroup) == 'object' ? data.educationGroup.value : data.educationGroup,
      specializationID : typeof(data.specialization) == 'object' ? data.specialization.id : null,
      specializationName : typeof(data.specialization) == 'object' ? data.specialization.value : data.specialization,
      isinActive : makeInactive,
      countryID : null,
      countryName : '',
      stateID: null,
      stateName : '',
      districtID: null,
      districtName : '',
      cityID: null,
      cityName : ''

    }
    console.log(masterData)
    this.service.submitMasterData(masterData).then((res)=>{
      if(res['statusCode']=== 200){
        this.responseMessage = 'Education Master Data Added Successfully'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.listOfEduCategory = [];
        this.listOfEduGroup = [];
        this.listOfEduSpecialization = [];
      } else {
        this.responseMessage = 'Cannot add Master Data. Please try again later.'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.listOfEduCategory = [];
        this.listOfEduGroup = [];
        this.listOfEduSpecialization = [];
      }
    })
  }

  addMasterDataProfession(data, makeInactive){
    let masterData = {
      categoryID :  typeof(data.highestprofession) == 'object' ? data.highestprofession.id : null,
      categoryName : typeof(data.highestprofession) == 'object' ? data.highestprofession.value : data.highestprofession,
      masterType : 2,
      groupID : typeof(data.professionGroup) == 'object' ? data.professionGroup.id : null,
      groupName : typeof(data.professionGroup) == 'object' ? data.professionGroup.value : data.professionGroup,
      specializationID : typeof(data.profSpecialization) == 'object' ? data.profSpecialization.id : null,
      specializationName : typeof(data.profSpecialization) == 'object' ? data.profSpecialization.value : data.profSpecialization,
      isinActive : makeInactive,
      countryID : null,
      countryName : '',
      stateID: null,
      stateName : '',
      districtID: null,
      districtName : '',
      cityID: null,
      cityName : ''
    }
    console.log(masterData)

    this.service.submitMasterData(masterData).then((res)=>{
      if(res['statusCode']=== 200){
        this.responseMessage = 'Profession Master Data Added Successfully'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.listOfProfCategory = [];
        this.listOfProfGroup = [];
        this.listOfProfSpecialization = [];
      } else {
        this.responseMessage = 'Cannot add Master Data. Please try again later.'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
    })
  }

  addMasterDataUniversity(data, makeInactive){
    let masterData = {
      categoryID :  null,
      categoryName : typeof(data.university) == 'object' ? data.university.value : data.university,
      masterType : 3,
      groupID : null,
      groupName : '',
      specializationID :null,
      specializationName : '',
      isinActive : makeInactive,
      countryID : null,
      countryName : '',
      stateID: null,
      stateName : '',
      districtID: null,
      districtName : '',
      cityID: null,
      cityName : ''
    }
    console.log(masterData)

    this.service.submitMasterData(masterData).then((res)=>{
      if(res['statusCode']=== 200){
        this.responseMessage = 'University Added To Master Data Successfully'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.listOfProfCategory = [];
        this.listOfProfGroup = [];
        this.listOfProfSpecialization = [];
      } else {
        this.responseMessage = 'Cannot add Master Data. Please try again later.'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
    })
  }


  addMasterDataCaste(data, makeInactive){
    let masterData = {
      categoryID :  null,
      categoryName : typeof(data.caste) == 'object' ? data.caste.value : data.caste,
      masterType : 5,
      groupID : null,
      groupName : '',
      specializationID :null,
      specializationName : '',
      isinActive : makeInactive,
      countryID : null,
      countryName : '',
      stateID: null,
      stateName : '',
      districtID: null,
      districtName : '',
      cityID: null,
      cityName : ''
    }
    console.log(masterData)

    this.service.submitMasterData(masterData).then((res)=>{
      if(res['statusCode']=== 200){
        this.responseMessage = 'caste Added To Master Data Successfully'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.listOfProfCategory = [];
        this.listOfProfGroup = [];
        this.listOfProfSpecialization = [];
      } else {
        this.responseMessage = 'Cannot add Master Data. Please try again later.'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
    })
    this.addCaste=false;
  }


   addMasterDataSubCaste(data, makeInactive){
    let masterData = {
      categoryID :  null,
      categoryName :  typeof(data.subcaste) == 'object' && data.subcaste != null ? data.subcaste?.value : data.subcaste ? data.subcaste : '',
      masterType : 6,
      groupID : null,
      groupName : this.listOfCastes[0]?.value,
      specializationID :null,
      specializationName : '',
      isinActive : makeInactive,
      countryID : null,
      countryName : '',
      stateID: null,
      stateName : '',
      districtID: null,
      districtName : '',
      cityID: null,
      cityName : ''
    }
    console.log(masterData)

    this.service.submitMasterData(masterData).then((res)=>{
      if(res['statusCode']=== 200){
        this.responseMessage = 'caste Added To Master Data Successfully'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.listOfProfCategory = [];
        this.listOfProfGroup = [];
        this.listOfProfSpecialization = [];
      } else {
        this.responseMessage = 'Cannot add Master Data. Please try again later.'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
    })
    this.addSubCaste=false;
  }
  addMasterDataCity(data, makeInactive){
    if((typeof(data.country) != 'object') &&(this.searchableCountryList?.some(country => country.value.toLowerCase() == data.country.toLowerCase()))) {
      this.responseMessage = 'Cannot add to master data as it already exists.'
      this.successModal.show();
      this.addCountry = false;
      this.cityMasterForm.patchValue({country: ''})
    } else if((typeof(data.state) != 'object') && (this.searchableStateList?.some(state => state.value.toLowerCase() == data.state.toLowerCase()))){
      this.responseMessage = 'Cannot add to master data as it already exists.'
      this.successModal.show();
      this.addState = false;
      this.cityMasterForm.patchValue({state: ''})
    } else if((typeof(data.district) != 'object') && (this.searchableDistrictList?.some(district => district.value.toLowerCase() == data.district.toLowerCase()))){
      this.responseMessage = 'Cannot add to master data as it already exists.'
      this.successModal.show();
      this.addDistrict = false;
      this.cityMasterForm.patchValue({district: ''})
    } else if((typeof(data.city) != 'object') && (this.searchableCityList?.some(city => city.value.toLowerCase() == data.city.toLowerCase()))){
      this.responseMessage = 'Cannot add to master data as it already exists.'
      this.successModal.show();
      this.addCity = false;
      this.cityMasterForm.patchValue({city: ''})
    }
    else {
    let masterData = {
      countryID : typeof(data.country) == 'object' && data.country != null ? data.country?.id : null,
      countryName : typeof(data.country) == 'object' && data.country != null ? data.country?.value : data.country ? data.country : '',
      stateID: typeof(data.state) == 'object' && data.state != null ? data.state?.id : null,
      stateName : typeof(data.state) == 'object' && data.state != null ? data.state?.value : data.state ? data.state : '',
      districtID: typeof(data.district) == 'object' && data.district != null ? data.district?.id : null,
      districtName : typeof(data.district) == 'object' && data.district != null ? data.district?.value : data.district ? data.district : '',
      cityID: typeof(data.city) == 'object' && data.city != null ? data.city?.id : null,
      cityName : typeof(data.city) == 'object' && data.city != null ? data.city?.value : data.city ? data.city : '',
      masterType : 4,
      isinActive : makeInactive,
      categoryID : null,
      categoryName : '',
      groupID : null,
      groupName : '',
      specializationID : null,
      specializationName : '',
    }
    this.service.submitMasterData(masterData).then((res)=>{
      if(res['statusCode']=== 200){
        this.responseMessage = 'Added to Master Data Successfully'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.cityMasterForm.reset();
        this.listOfCountries = [];
        this.listOfStates = [];
        this.listOfDistricts = [];
        this.listOfCities = [];
        this.addCountry = false;
        this.addState = false;
        this.addDistrict = false;
        this.addCity = false;
      } else {
        this.responseMessage = 'Cannot add Master Data. Please try again later.'
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
        this.cityMasterForm.reset();
        this.listOfCountries = [];
        this.listOfStates = [];
        this.listOfDistricts = [];
        this.listOfCities = [];
        this.addCountry = false;
        this.addState = false;
        this.addDistrict = false;
        this.addCity = false;
      }
    })
   }
 }

  getSelectedEduCategory(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfEduCategory.some(eduCategory => val.id === eduCategory.id)) {
      return;
    } else {
      this.listOfEduCategory.push(val);
    }
    const selectededuCategory = event.option.value;
  }
  getCityText() {
    return null;
  }
  clearText(event) {
    // const val = this.advancedFormSearch.value.university;
    // if (typeof(val) == 'string') {
    //   this.advancedFormSearch.patchValue({university: ''})
    // }
  }

  onInputCountryChange(event) {
    let val = event.target.value
    if(val.length >=3 ) {
      this.addCountry = true;
    } else {
      this.addCountry = false;
    }
  }

  async onInputCasteChange(event) {
    let val = event.target.value
    if(val.length >=3 ) {

    await  this.filteredCaste(val,'Caste');
      if(this.searchableCasteList.length>0){

      this.addCaste =false;
      }
      else{
        this.addCaste = true;
      }
    }
    else{
      this.searchableCasteList=[];
    }
  
  }

  async   onInputSubCasteChange(event) {
     let val = event.target.value.toLowerCase();
     if(val.length >=3 ) {
       await this.service.
      loadMasterData('Caste')
      .then((response) => {
        this.CompleteCasteList = response['result'];
      })
     this.searchableSubCasteList=[];
       this.listOfCastes.forEach((caste) => {
        if (caste.extraID) {
          const ids = caste.extraID.split(',').map(Number);
  
          ids.forEach((id) => {
            const match = this.CompleteCasteList.find(item => 
              item.id === id &&
              item.value &&
              item.value.toLowerCase().startsWith(val)
            );
  
            if (match && !this.searchableSubCasteList.some(c => c.id === match.id)) {
              this.searchableSubCasteList.push(match);
            }
          });
        }
      });
   const isPresentInCompleteList =  this.CompleteCasteList.some(item =>
    item.value?.toLowerCase().startsWith(val)
    );
      const isInSearchableList = this.searchableSubCasteList.some(item =>
    item.value?.toLowerCase().startsWith(val)
  );

    this.addSubCaste = isPresentInCompleteList && !isInSearchableList;
      }
      else{
          this.addSubCaste= false;
      }
    
    }


  
  onInputStateChange(event) {
    let val = event.target.value
    if(val.length >=3 ) {
      this.addState = true;
    } else {
      this.addState = false;
    }
  }

  onInputDistrictChange(event) {
    let val = event.target.value
    if(val.length >=3 ) {
      this.addDistrict = true;
    } else {
      this.addDistrict = false;
    }
  }

  onInputCityChange(event) {
    let val = event.target.value
    if(val.length >=3 ) {
      this.addCity = true;
    } else {
      this.addCity = false;
    }
  }

  getSelectedType(event: MatAutocompleteSelectedEvent, type) {
    if(type === 'Country')
    {
     const val = event.option.value
     if (this.listOfCountries.some(country => val.id === country.id)) {
       return;
     } else {
       this.listOfCountries.push(val);
     }
     const selectedCountry = event.option.value;
     this.selectedCountry = event.option.value.id;
     this.addCountry = false;
    }
   if(type === 'State')  
   {
      const val = event.option.value
     if (this.listOfStates.some(state => val.id === state.id)) {
       return;
     } else {
       this.listOfStates.push(val);
     }
     const selectedState = event.option.value;
     this.addState = false;
   }
   if(type === 'District')
    {
     const val = event.option.value
     if (this.listOfDistricts.some(district => val.id === district.id)) {
        return;
     } else {
        this.listOfDistricts.push(val);
     }
     const selectedDistrict = event.option.value;
     this.addDistrict = false;
   }
   if(type === 'City') 
   {
     const val = event.option.value
     if (this.listOfCities.some(city => val.id === city.id)) {
       return;
     } else {
       this.listOfCities.push(val);
     }
     const selectedCity = event.option.value;
     this.addCity = false;
    }
if (type === 'Caste')
   {
    let val = event.option.value;
    let value = JSON.stringify(val);  
    if (!value.toLowerCase().includes("caste no bar".toLowerCase())) {
     return; 
    }
    if (this.listOfCastes.some(caste => val.id === caste.id)) {
    return; 
    } 
    else 
    {
    this.listOfCastes.push(val); 
    }
     this.addSubCaste=false;
  }
  }

  addEduCategoryChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableEduCategoryList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfEduCategory.some(eduCategory => filterVal.id === eduCategory.id)) {
        return;
      } else {
        this.listOfEduCategory.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  addCountryChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableCountryList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfCountries.some(country => filterVal.id === country.id)) {
        return;
      } else {
        this.listOfCountries.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }

  addStateChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableStateList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfStates.some(state => filterVal.id === state.id)) {
        return;
      } else {
        this.listOfStates.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }

  addDistrictChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableDistrictList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfDistricts.some(district => filterVal.id === district.id)) {
        return;
      } else {
        this.listOfDistricts.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }


  addCityChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableCityList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfCities.some(city => filterVal.id === city.id)) {
        return;
      } else {
        this.listOfCities.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  addCasteChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableCasteList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfCastes.some(city => filterVal.id === city.id)) {
        return;
      } else {
        this.listOfCastes.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }


  filteredEduCategory(val: string,masterName) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableEduCategoryList = res['result'];
        if(this.searchableEduCategoryList.length <= 0){
          this.addEduCategory = true;
        } else {
          this.addEduCategory = false;
        }
      })
    } else {
      this.addEduCategory = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeCategory(university): void {
    const index = this.listOfEduCategory.indexOf(university);
    if (index >= 0) {
      this.listOfEduCategory.splice(index, 1);
    }
  }
  removeCountry(country): void {
    const index = this.listOfCountries.indexOf(country);
    if (index >= 0) {
      this.listOfCountries.splice(index, 1);
    }
    this.listOfCountries = [];
    this.listOfStates = [];
    this.listOfDistricts = [];
    this.listOfCities = [];
    this.addDistrict = false;
    this.addCity = false;
    this.addCountry = false;
    this.addState = false;
  }

   removeCaste(caste): void {
    const index = this.listOfCastes.indexOf(caste);
    if (index >= 0) {
      this.listOfCastes.splice(index, 1);
    }
    this.listOfCastes = [];
    this.listOfSubCastes = [];
     this.searchableSubCasteList = [];
  }


  removeState(state): void {
    const index = this.listOfStates.indexOf(state);
    if (index >= 0) {
      this.listOfStates.splice(index, 1);
    }
    this.listOfStates = [];
    this.listOfDistricts = [];
    this.listOfCities = [];
    this.addDistrict = false;
    this.addCity = false;
    this.addCountry = false;
    this.addState = false;
  } 

  removeDistrict(district): void {
    const index = this.listOfDistricts.indexOf(district);
    if (index >= 0) {
      this.listOfDistricts.splice(index, 1);
    }
    this.listOfDistricts = [];
    this.listOfCities = [];
    this.addCity = false;
    this.addDistrict = false;
    this.addCountry = false;
    this.addState = false;
  } 

  removeCity(city): void {
    const index = this.listOfCities.indexOf(city);
    if (index >= 0) {
      this.listOfCities.splice(index, 1);
    }
    this.listOfCities = [];
    this.addCountry = false;
    this.addState = false;
    this.addCity= false;
    this.addDistrict = false;
  } 

// =============================EDUCATION GROUP=============================
  addEduGroupChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableEduGroupList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfEduGroup.some(eduCategory => filterVal.id === eduCategory.id)) {
        return;
      } else {
        this.listOfEduGroup.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  getSelectedEduGroup(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfEduGroup.some(eduCategory => val.id === eduCategory.id)) {
      return;
    } else {
      this.listOfEduGroup.push(val);
    }
    const selectededuCategory = event.option.value;
  }
  filteredEduGroup(val: string,masterName) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableEduGroupList = res['result'];
        if(this.searchableEduGroupList.length <= 0){
          this.addEduGroup = true;
        } else {
          this.addEduGroup = false;
        }
      })
    } else {
      this.addEduGroup = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeGroup(university): void {
    const index = this.listOfEduGroup.indexOf(university);
    if (index >= 0) {
      this.listOfEduGroup.splice(index, 1);
    }
  }

  // ----------------------- Education Specialization -------------------------
  addEduSpecializationChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableEduSpecializationList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfEduSpecialization.some(eduCategory => filterVal.id === eduCategory.id)) {
        return;
      } else {
        this.listOfEduSpecialization.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  getSelectedEduSpecialization(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfEduSpecialization.some(eduCategory => val.id === eduCategory.id)) {
      return;
    } else {
      this.listOfEduSpecialization.push(val);
    }
    const selectededuCategory = event.option.value;
  }
  filteredEduSpecialization(val: string,masterName,groupID) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val, groupID).then((res) => {
        this.searchableEduSpecializationList = res['result'];
        if(this.searchableEduSpecializationList.length <= 0){
          this.addEduSpecialization = true;
        } else {
          this.addEduSpecialization = false;
        }
      })
    } else {
      this.addEduSpecialization = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeSpecialization(university): void {
    const index = this.listOfEduSpecialization.indexOf(university);
    if (index >= 0) {
      this.listOfEduSpecialization.splice(index, 1);
    }
  }


  // -------------------------Profession -------------------------------

  getSelectedProfCategory(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfProfCategory.some(profCategory => val.id === profCategory.id)) {
      return;
    } else {
      this.listOfProfCategory.push(val);
    }
    const selectedProfCategory = event.option.value;
  }

  addProfCategoryChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableProfCategoryList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfProfCategory.some(ProfCategory => filterVal.id === ProfCategory.id)) {
        return;
      } else {
        this.listOfProfCategory.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  filteredProfCategory(val: string,masterName) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableProfCategoryList = res['result'];
        if(this.searchableProfCategoryList.length <= 0){
          this.addProfCategory = true;
        } else {
          this.addProfCategory = false;
        }
      })
    } else {
      this.addProfCategory = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeProfCategory(university): void {
    const index = this.listOfProfCategory.indexOf(university);
    if (index >= 0) {
      this.listOfProfCategory.splice(index, 1);
    }
  }
// =============================ProfCATION GROUP=============================
  addProfGroupChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableProfGroupList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfProfGroup.some(ProfCategory => filterVal.id === ProfCategory.id)) {
        return;
      } else {
        this.listOfProfGroup.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  getSelectedProfGroup(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfProfGroup.some(ProfCategory => val.id === ProfCategory.id)) {
      return;
    } else {
      this.listOfProfGroup.push(val);
    }
    const selectedProfCategory = event.option.value;
  }
  filteredProfGroup(val: string,masterName) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableProfGroupList = res['result'];
        if(this.searchableProfGroupList.length <= 0){
          this.addProfGroup = true;
        } else {
          this.addProfGroup = false;
        }
      })
    } else {
      this.addProfGroup = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeProfGroup(university): void {
    const index = this.listOfProfGroup.indexOf(university);
    if (index >= 0) {
      this.listOfProfGroup.splice(index, 1);
    }
  }

  // ----------------------- Profcation Specialization -------------------------
  addProfSpecializationChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableProfSpecializationList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfProfSpecialization.some(ProfCategory => filterVal.id === ProfCategory.id)) {
        return;
      } else {
        this.listOfProfSpecialization.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  getSelectedProfSpecialization(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfProfSpecialization.some(ProfCategory => val.id === ProfCategory.id)) {
      return;
    } else {
      this.listOfProfSpecialization.push(val);
    }
    const selectedProfCategory = event.option.value;
  }
  filteredProfSpecialization(val: string,masterName, groupID) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val, groupID).then((res) => {
        this.searchableProfSpecializationList = res['result'];
        if(this.searchableProfSpecializationList.length <= 0){
          this.addProfSpecialization = true;
        } else {
          this.addProfSpecialization = false;
        }
      })
    } else {
      this.addProfSpecialization = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeProfSpecialization(university): void {
    const index = this.listOfProfSpecialization.indexOf(university);
    if (index >= 0) {
      this.listOfProfSpecialization.splice(index, 1);
    }
  }

  //----------------------------UNIVERSITY----------------------------------

  getSelectedUniversity(event: MatAutocompleteSelectedEvent) {
    const val = event.option.value
    if (this.listOfUniversities.some(Uni => val.id === Uni.id)) {
      return;
    } else {
      this.listOfUniversities.push(val);
    }
    const selectedUni = event.option.value;
  }

  addUniversityChip(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const filterVal = this.searchableUniversityList.filter(val => val.value.trim() == value.trim())[0];
      if (this.listOfUniversities.some(uni => filterVal.id === uni.id)) {
        return;
      } else {
        this.listOfUniversities.push(filterVal);
      }
    }
    if (input) {
      input.value = '';
    }
  }
  filteredCountry(val: string,masterName) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableCountryList = res['result'];
      })
    } else {
      this.addCountry = false;
    }
  }

  filteredState(val: string,masterName,groupID) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val, groupID).then((res) => {
        this.searchableStateList = res['result'];
      })
    } else {
      this.addState = false;
    }
  } 

  filteredDistrict(val: string,masterName,groupID) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val, groupID).then((res) => {
        this.searchableDistrictList = res['result'];
      })
    } else {
      this.addDistrict = false;
    }
  } 

  filteredCity(val: string,masterName,groupID) {
    console.log(groupID)
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val, groupID).then((res) => {
        this.searchableCityList = res['result'];
      })
    } else {
      this.addCity = false;
    }
  } 
  async filteredCaste(val: string,masterName) {
    if (val.length > 2) {
   
      await this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableCasteList = res['result'];
      })
   

    
    } else {
      this.addCaste = false;
    }
  }

  filteredUniversity(val: string,masterName) {
    if (val.length > 2) {
      this.service.loadSearchMasterData(masterName, val).then((res) => {
        this.searchableUniversityList = res['result'];
        if(this.searchableUniversityList.length <= 0){
          this.universityToMD = true;
        } else {
          this.universityToMD = false;
        }
      })
    } else {
      this.addProfCategory = false;
      console.log('enter 3 digits atleast')
    }
  }
  removeUniversity(university): void {
    const index = this.listOfUniversities.indexOf(university);
    if (index >= 0) {
      this.listOfUniversities.splice(index, 1);
    }
  }
}
